import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';



@Injectable()
export class OrderUiEffects {



  constructor(private actions$: Actions) {}

}
